var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('div',{staticClass:"wrapper"},[_c('TheHeader'),_c('main',{staticClass:"main"},[_c('router-view')],1),_c('TheFooter')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }